module.exports = __webpack_public_path__ + "media/images/emblems/Uzwil_blazono-76871af09b6dc06c89fd10d843b539a2.png";